export default class notEmptyValidator {
    constructor() {
    }

    validate(field, value) {
        const type = field?.type;

        // Checkbox + Radio
        if(!!type && (type === 'checkbox' || type === 'radio')) {
            if(!field.checked) {
                return false;
            }
        }
        // Text fields
        else {
            if(!value) {
                return false;
            }
        }

        return true;
    }
}
